import { SingleSelectFieldFilter } from 'module/types/filter-field/filter/single-select';
import { FC } from 'react';
import { SingleSelectBaseFilterToText } from './single-select-base-filter';

export const SingleSelectFilterToText: FC<{
  filter: SingleSelectFieldFilter;
}> = ({ filter }) => {
  const {
    field: {
      metaData: { options },
    },
  } = filter;

  return <SingleSelectBaseFilterToText filter={filter} options={options} />;
};
